import * as React from "react";
import { Box, Card, CardContent, Skeleton, Typography } from "@mui/material";

export const ReservesResultSkeleton = () => {
  return (
    <Card sx={{ mb: 2 }}>
      <CardContent>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Skeleton
            animation="wave"
            variant="rectangular"
            width={80}
            height={120}
            sx={{ flexShrink: 0 }}
          />

          <Box sx={{ flex: 1 }}>
            <Skeleton
              animation="wave"
              height={14}
              width="80%"
              sx={{ mb: 0.75 }}
            />
            <Skeleton animation="wave" height={14} width="60%" sx={{ mb: 2 }} />

            <Typography>
              <Skeleton animation="wave" width="30%" height={10} />
            </Typography>
            <Typography>
              <Skeleton animation="wave" width="30%" height={10} />
            </Typography>
            <Typography>
              <Skeleton animation="wave" width="30%" height={10} />
            </Typography>
            <Typography>
              <Skeleton animation="wave" width="40%" height={10} />
            </Typography>

            <Box sx={{ mt: 2, display: "flex", gap: 1 }}>
              <Skeleton
                animation="wave"
                variant="rectangular"
                width={120}
                height={36}
              />
              <Skeleton
                animation="wave"
                variant="rectangular"
                width={120}
                height={36}
              />
            </Box>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};
